export type AdminFeature =
  | 'dashboard'
  | 'students'
  | 'reminders'
  | 'records'
  | 'trash'
  | 'teachers'
  | 'fees'
  | 'payments'
  | 'callFollowups'
  | 'reports'
  | 'accounts'
  | 'assignments'
  | 'notificationsDiagnostics'

export const enabledAdminFeatures: Record<AdminFeature, boolean> = {
  dashboard: true,
  students: true,
  reminders: true,
  records: true,
  trash: true,
  teachers: false,
  fees: false,
  payments: false,
  callFollowups: false,
  reports: false,
  accounts: false,
  assignments: false,
  notificationsDiagnostics: false,
}

export function isAdminFeatureEnabled(feature: AdminFeature): boolean {
  return enabledAdminFeatures[feature]
}

export const lockedFeatureLabels: Record<AdminFeature, string> = {
  dashboard: 'Dashboard',
  students: 'Students',
  reminders: 'Reminders',
  records: 'Advanced Records',
  trash: 'Inactive / Trash',
  teachers: 'Teachers',
  fees: 'Fees',
  payments: 'Payments',
  callFollowups: 'Call Follow-ups',
  reports: 'Reports',
  accounts: 'Account Repair',
  assignments: 'Access Repair',
  notificationsDiagnostics: 'Notification Diagnostics',
}

export type AdminRouteFeature = {
  path: string
  feature: AdminFeature
}

export const adminRouteFeatures: AdminRouteFeature[] = [
  { path: '/admin', feature: 'dashboard' },
  { path: '/admin/students', feature: 'students' },
  { path: '/admin/teachers', feature: 'teachers' },
  { path: '/admin/records', feature: 'records' },
  { path: '/admin/accounts', feature: 'accounts' },
  { path: '/admin/assignments', feature: 'assignments' },
  { path: '/admin/call-attempts', feature: 'callFollowups' },
  { path: '/admin/trash', feature: 'trash' },
  { path: '/admin/reminders', feature: 'reminders' },
  { path: '/admin/fees', feature: 'fees' },
  { path: '/admin/payments', feature: 'payments' },
  { path: '/admin/notifications', feature: 'notificationsDiagnostics' },
  { path: '/admin/reports', feature: 'reports' },
]

export function adminFeatureForPath(path: string): AdminFeature | undefined {
  return adminRouteFeatures.find((route) => route.path === path)?.feature
}
